import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthenticatorService } from './authenticator.service';
import { Correos } from '../Interfaces/correos.interface';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CorreosService {
    baseUrl: string = environment.baseUrl;

    constructor(private http: HttpClient, private auth: AuthenticatorService) {}

    obtenerCorreos(noControl: string): Observable<Correos> {
        const headers = this.auth.headers;
        const url_api = `${this.baseUrl}/correos/${noControl}`;
        return this.http.get<Correos>(url_api, { headers });
    }

    correoActivado(noControl: string): Observable<any> {
        const headers = this.auth.headers;
        const url_api = `${this.baseUrl}/correo-activo/${noControl}`;
        return this.http.get<Correos>(url_api, { headers });
    }

    validarActivado(noControl: string): Observable<any> {
        const headers = this.auth.headers;
        const url_api = `${this.baseUrl}/validar-correo/${noControl}`;
        return this.http.get<any>(url_api, { headers });
    }

    enviarInc(fechaI: string, fechaF: string): Observable<any> {
        const headers = this.auth.headers;
        const url_api = `${this.baseUrl}/incidents-correos/${fechaI}/${fechaF}`;
        return this.http.get<any>(url_api, { headers });
    }

    update(noControl: string, correo: Partial<Correos>): Observable<any> {
        const headers = this.auth.headersValidateCorreo;
        const url_api = `${this.baseUrl}/correos/${noControl}`;
        return this.http.patch<any>(url_api, correo, { headers });
    }
}
